export default {
  workingHour: state => state.workingHour,
  listBusinessBlockTime: state => state.listBusinessBlockTime,
  listStaffBlockTime: state => state.listStaffBlockTime,
  blockTime: state => state.blockTime
}
